import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { ConfiguredWorkspace } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface UseGetConfiguredRelativityWorkspacesOptions {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

const useGetConfiguredRelativityWorkspaces = (options: UseGetConfiguredRelativityWorkspacesOptions = {}) => {
  const { enabled = true, refetchOnWindowFocus = false } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getConfiguredWorkspaces = async (): Promise<ConfiguredWorkspace[]> => {
    const url = `${APIBaseChronos}/api/relativity-mappings/configured`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch configured workspaces: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.ConfiguredRelativityWorkspaces], getConfiguredWorkspaces, {
    enabled,
    refetchOnWindowFocus,
    retry: (failureCount, error) => {
      if (error instanceof Error && (error.message.includes('401') || error.message.includes('403'))) {
        return false;
      }
      return failureCount < 2;
    },
  });
};

export default useGetConfiguredRelativityWorkspaces;
